import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ReportedAnswereService } from '../reported-answere.service';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import Swal from "sweetalert2";
@Component({
  selector: 'app-question-detail',
  templateUrl: './question-detail.component.html',
  styleUrls: ['./question-detail.component.css']
})
export class QuestionDetailComponent implements OnInit {
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  formSubmitted: boolean = false;
  NotificationForm: FormGroup;
  private modalRef: NgbModalRef;
  questiondetailList = []
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  question: string;
  report_id: any;
  constructor(
    private modalService: NgbModal,
    private ReportedAnswereService: ReportedAnswereService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router, private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.report_id = this.route.snapshot.params["id"];
  

    this.route.queryParams.subscribe(param => {
      this.question = param['question'];
    });
    // this.question = "sdasdasdasdsaklsadkasd"
    this.getreportList();
  }
  getreportList() {

    this.spinner.show();
    this.ReportedAnswereService.GetReportQuestionDetail(this.report_id).subscribe(res => {
      if (res["message"] = "Success") {
        this.questiondetailList = res.data.reportedQuestionDetailList;
        this.spinner.hide();
      } else {
        this.questiondetailList = [];
        this.spinner.hide();
      }
    });
  }
  reportedId:any;

  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.reportedId = row;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteRecord(record: any) {
    this.spinner.show();
    this.ReportedAnswereService.DeletereportedQuestion(this.reportedId).subscribe(res => {
      console.log('res',res)
     
      if ((res["message"] == "Success")) {  
        this.getreportList();
        Swal.fire("Success", "Reported Question Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
      } else {
        Swal.fire("Success", "Reported Question Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();

      }
    });
    this.spinner.hide();

  }
  navigateReportDetail(row) {
    this.router.navigate(['main/report-detail/' + row._id]);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}

